<ng-container *ngIf="loading; then loadingTemplate; else content"></ng-container>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
<ng-template #loadingTemplate>
  <div class="loading-wrapper">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
